import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MultiSegmentProgressBarComponent } from '../../common/multi-segment-progress-bar/multi-segment-progress-bar.component';
import { StatusBadgeComponent } from '../../common/status-badge/status-badge.component';
import { ExecutionCycle } from '../execution-cycle-card/execution-cycle-card.component';

@Component({
  selector: 'app-latest-execution-view',
  standalone: true,
  imports: [CommonModule, StatusBadgeComponent, MultiSegmentProgressBarComponent],
  templateUrl: './latest-execution-view.component.html',
  styleUrl: './latest-execution-view.component.scss'
})
export class LatestExecutionViewComponent {
  @Input() cycle!: ExecutionCycle;
  /** Optional release/version tag shown beside the cycle name (e.g. "release 24_10") */
  @Input() badge?: string;
  /** When true renders Bootstrap placeholder skeleton instead of real data. */
  @Input() isLoading: boolean = false;

  get completedLabel(): string {
    if (!this.cycle) return '';
    return `${this.cycle.completedCount} of ${this.cycle.totalCount} completed`;
  }

  formatDate(dateString?: string): string {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return 'N/A';
    const day      = String(date.getDate()).padStart(2, '0');
    const month    = String(date.getMonth() + 1).padStart(2, '0');
    const year     = String(date.getFullYear()).slice(-2);
    const hours24  = date.getHours();
    const hours12  = hours24 % 12 || 12;
    const hour     = String(hours12).padStart(2, '0');
    const minute   = String(date.getMinutes()).padStart(2, '0');
    const second   = String(date.getSeconds()).padStart(2, '0');
    const meridiem = hours24 >= 12 ? 'pm' : 'am';
    return `${day}/${month}/${year}, ${hour}:${minute}.${second} ${meridiem}`;
  }

  calculateDuration(): string {
    if (!this.cycle?.startTime || !this.cycle?.endTime) return 'N/A';
    const diff = new Date(this.cycle.endTime).getTime() - new Date(this.cycle.startTime).getTime();
    if (diff < 0) return 'N/A';
    const h = Math.floor(diff / 3_600_000);
    const m = Math.floor((diff % 3_600_000) / 60_000);
    const s = Math.floor((diff % 60_000) / 1000);
    if (h > 0) return `${h}h ${m}m ${s}s`;
    if (m > 0) return `${m}m ${s}s`;
    return `${s}s`;
  }
}
